import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import Header from "../components/header";
import Footer from "../components/footer";
import SocialFooter from "../components/social-footer";
import {title, SEO} from '../content/meta.yaml';


import "../../sass/style.scss";

const TemplateWrapper = ({ children }) => {

    return (
            <div>
                <Helmet title={title}>
                    <meta name="description" content={SEO.description}/>
                    <meta name="keywords" content={SEO.keywords}/>
                    <meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate"/>
                    <meta http-equiv="Pragma" content="no-cache"/>
                    <meta http-equiv="Expires" content="0"/>
                    <link rel='shortcut icon' type='image/x-icon' href='/favicon.ico' />

                    <script async src="https://www.googletagmanager.com/gtag/js?id=UA-152876055-1"></script>
                    <script>
                    {`
                      window.dataLayer = window.dataLayer || [];
                      function gtag(){dataLayer.push(arguments);}
                      gtag('js', new Date());

                      gtag('config', 'UA-152876055-1');
                    `}
                    </script>
                </Helmet>
                <Header/>
                {children}
                <SocialFooter />
                <Footer/>
            </div>
    );
};

TemplateWrapper.propTypes = {
    children: PropTypes.func
};

export default TemplateWrapper;
